module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "accordion",
    class: _vm.rootClasses
  }, [_c('button', {
    staticClass: "u-reset accordion--head",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onRequestChange(!_vm.state.isActive)
      }
    }
  }, [_vm._t("head", null, {
    isActive: _vm.state.isActive
  })], 2), _vm._v(" "), _c('div', {
    ref: "body",
    staticClass: "accordion--body",
    on: {
      "transitionend": function($event) {
        _vm.finishAnimation($event)
      }
    }
  }, [_vm._t("body")], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-39b96fc2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39b96fc2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/ui/accordion/index.vue
// module id = 531
// module chunks = 7